import { GoToBillingCTA, GoToPayoutSettingsCTA } from "./ctas";
import { CONTACT_US_IF_FURTHER_HELP } from "./shared";
export var BillingAndPayoutIA = function BillingAndPayoutIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    },
    secondaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getSecondaryCTA;
        return (_getSecondaryCTA = getSecondaryCTA(context, strictLocalize)) === null || _getSecondaryCTA === void 0 ? void 0 : _getSecondaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getSecondaryCTA2, _getSecondaryCTA2$get;
        return (_getSecondaryCTA2 = getSecondaryCTA(context, strictLocalize)) === null || _getSecondaryCTA2 === void 0 ? void 0 : (_getSecondaryCTA2$get = _getSecondaryCTA2.getLink) === null || _getSecondaryCTA2$get === void 0 ? void 0 : _getSecondaryCTA2$get.call(_getSecondaryCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return UPDATE_BILLING_AND_PAYOUT_TITLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [UPDATE_BILLING_AND_PAYOUT_DESCRIPTION(strictLocalize), CONTACT_US_IF_FURTHER_HELP(strictLocalize)];
    }
  };
};
var UPDATE_BILLING_AND_PAYOUT_TITLE = function UPDATE_BILLING_AND_PAYOUT_TITLE(strictLocalize) {
  return strictLocalize({
    id: "EvYxe0",
    defaultMessage: [{
      "type": 0,
      "value": "Mettre à jour les informations de facturation et de paiement"
    }]
  });
};
var UPDATE_BILLING_AND_PAYOUT_DESCRIPTION = function UPDATE_BILLING_AND_PAYOUT_DESCRIPTION(strictLocalize) {
  return strictLocalize({
    id: "ukamht",
    defaultMessage: [{
      "type": 0,
      "value": "Vous pouvez modifier les informations de facturation et de paiement de votre compte en vous rendant sur la page « Paramètres du compte »."
    }]
  });
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return GoToBillingCTA(strictLocalize);
};
var getSecondaryCTA = function getSecondaryCTA(_context, strictLocalize) {
  return GoToPayoutSettingsCTA(strictLocalize);
};